const transformSurveys = ({ actions = [] }) =>
  actions?.map(({ id, name, displayName, type }) => ({
    id,
    name,
    displayName,
    type,
  }));

export default transformSurveys;
